import { render, staticRenderFns } from "./addPlatformCoupon.vue?vue&type=template&id=60d719c4"
import script from "./addPlatformCoupon.vue?vue&type=script&lang=js"
export * from "./addPlatformCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports